// extracted by mini-css-extract-plugin
export default {"card_container":"UserMyAdsCards_card_container__hSQBh","cards_contair_responsive":"UserMyAdsCards_cards_contair_responsive__sULXs"};